// src/lib/viewerTimezone.ts
// One source of truth for "what time is it for the person looking at the dashboard".
// Every Operations / Circularity chart sends VIEWER_TZ as ?tz= so the backend cuts
// hours, days and months on the viewer's clock (fallback: Europe/Amsterdam).

export const FALLBACK_TZ = "Europe/Amsterdam"

export const VIEWER_TZ: string = (() => {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || FALLBACK_TZ
    } catch {
        return FALLBACK_TZ
    }
})()

const pad = (n: number) => String(n).padStart(2, "0")

/**
 * Calendar day the person picked, as YYYY-MM-DD.
 * The date picker gives a Date at LOCAL midnight, so we read the local calendar day.
 * (Converting through UTC or another timezone can shift it by one day.)
 */
export const toYMD = (value: Date | string | null | undefined): string | null => {
    if (!value) return null
    const d = value instanceof Date ? value : new Date(value)
    if (isNaN(d.getTime())) return null
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

/** "2026-10-10 14:05:09" in the viewer's timezone (for CSV timestamps). */
export const fmtViewerTime = (value: string | number | Date | null | undefined): string => {
    if (value === null || value === undefined || value === "") return "-"
    const d = value instanceof Date ? value : new Date(value)
    if (isNaN(d.getTime())) return String(value)
    const parts = new Intl.DateTimeFormat("en-CA", {
        timeZone: VIEWER_TZ, year: "numeric", month: "2-digit", day: "2-digit",
        hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23",
    }).formatToParts(d)
    const get = (type: string) => parts.find(p => p.type === type)?.value ?? ""
    return `${get("year")}-${get("month")}-${get("day")} ${get("hour")}:${get("minute")}:${get("second")}`
}